import React from 'react';

export const EstimatedQuoteText = ({productVersionIdRef}) =>{
  let EstQuoteText;
  switch(productVersionIdRef){
    case 'iic-CA-Homeowners-v01-00-00':
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This is based on the property information you've entered so far with some basic coverage. If you are happy with
              this estimate, click the <span className={'bold-text'}>Apply Now</span> button below.
            </p>
            <p>Otherwise, you can update the coverages and click the <span className={'bold-text'}>Recalculate</span> button to see the updated premium.</p>
          </div>
      );
      break;
    case 'iic-CA-PersonalAuto-v01-00-00':
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This is based on the information you've entered so far with some basic coverage. If you are happy with
                this estimate, click the <span className={'bold-text'}>Apply Now</span> button below.
            </p>
            <p>Otherwise, you can adjust the coverages below to see the updated premium.</p>
          </div>
      );
      break;
    default:
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This is based on the information you've entered so far with some basic coverage. If you are happy with
              this estimate, click the <span className={'bold-text'}>Apply Now</span> button below.
            </p>
            <p>Otherwise, you can update the coverages to see the updated premium.</p>
          </div>
      );
  }
  return EstQuoteText;
}



